import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {
  displayHide = false;
  showCloseButton = false;

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.displayHide = params['displayHide'];
      if (this.displayHide) {
        this.showCloseButton = true;
      }
    });
  }

  closeCustomer(): void {
    const closeurl =
      'https://www.car-research.com/carinteractive/WebXRM/ClosePage.aspx?action=save&program=vb';
    window.location.href = closeurl;
  }

}
